"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _AppRegistry = _interopRequireDefault(require("react-native-web/dist/exports/AppRegistry"));

function replaceHydrateFunction() {
  return (element, rootTag, callback) => {
    const RootComponent = () => element;

    _AppRegistry.default.registerComponent('main', () => RootComponent);

    _AppRegistry.default.runApplication('main', {
      initialProps: {},
      rootTag,
      callback
    });
  };
}

exports.replaceHydrateFunction = replaceHydrateFunction;